/**
 * Death-shop purchase undo records + apply (keeps InventorySystem slim).
 */

import { decrementStackOrClear } from './consumableStacks.js';

export function createStackPurchaseRecord(slotIndex, itemId, costPaid, deathShop = false) {
  return { kind: 'stack', slotIndex, itemId, costPaid, deathShop: Boolean(deathShop) };
}

export function createNewPurchaseRecord(slotIndex, itemId, costPaid, deathShop = false) {
  return { kind: 'new', slotIndex, itemId, costPaid, deathShop: Boolean(deathShop) };
}

export function createCraftPurchaseRecord(slotIndex, itemId, costPaid, consumed, deathShop = false) {
  return {
    kind: 'craft',
    slotIndex,
    itemId,
    costPaid,
    consumed,
    deathShop: Boolean(deathShop)
  };
}

export function applyUndoLastBuy(inventory, record) {
  if (!record) return { success: false, reason: 'nothing_to_undo' };
  if (record.deathShop && !inventory?.owner?.isDead) {
    return { success: false, reason: 'not_dead' };
  }

  const slot = inventory.slots[record.slotIndex];
  if (record.kind === 'stack') {
    if (!slot || slot.id !== record.itemId) {
      return { success: false, reason: 'purchase_missing' };
    }
    decrementStackOrClear(inventory.slots, record.slotIndex);
  } else if (record.kind === 'new') {
    if (!slot || slot.id !== record.itemId) {
      return { success: false, reason: 'purchase_missing' };
    }
    inventory.slots[record.slotIndex] = null;
  } else if (record.kind === 'craft') {
    if (!slot || slot.id !== record.itemId) {
      return { success: false, reason: 'purchase_missing' };
    }
    inventory.slots[record.slotIndex] = null;
    (record.consumed || []).forEach(({ index, snapshot }) => {
      inventory.slots[index] = snapshot;
    });
  } else {
    return { success: false, reason: 'unknown_kind' };
  }

  inventory.owner.gold += record.costPaid;
  inventory.recalculateStats();
  return { success: true, refunded: record.costPaid };
}

export function shouldClearPurchaseOnSell(record, soldSlotIndex) {
  if (!record) return false;
  if (record.slotIndex === soldSlotIndex) return true;
  return false;
}
